module.exports = __webpack_public_path__ + "img/shutterstock_444101470.c934e50c.jpg";